<template>
  <Content>
    <Card style="text-align: center;" :dis-hover="true">
      <template slot="title">{{$t('manage.resources.available')}}</template>

      <Select v-model="language" not-found-text="No match" :placeholder="$t('license.form.placeholder.country')">
        <Option value="all">{{$t('manage.resources.allLanguages')}}</Option>
        <Option value="en">English</Option>
        <Option value="no">Norwegian</Option>
        <Option value="fr">French</Option>
        <Option value="sw">Swahili</Option>
      </Select>

      <Row :gutter="8">
        <i-Col class="card-container" :xs="12" :sm="12" :md="8" v-for="file in langFiles" :key="file.name">
          <Card>
            <a :href="`${publicPath}files/${file.name}.${file.ext}`" :download="`${file.name}.${file.ext}`" class="file">
              <img :src="require(`@/assets/thumbs/${file.name}.png`)">
              <h3>{{file.title}}</h3>
            </a>
          </Card>
        </i-Col>
      </Row>
    </Card>
  </Content>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      language: "all",
      files: [
        {name: 'Training Guide Entrepreneurship lab 10.10_22-min', ext: 'pdf', title: 'Training Guide Entrepreneurship Lab', lang: 'en'},
        {name: 'Leap Util Usage guide', ext: 'pdf', title: 'Leap Util Usage guide', lang: 'en'},
      ]
    }
  },
  computed: {
    langFiles() {
      return this.files.filter(f => this.language === null || this.language === "all" || ["all", this.language].includes(f.lang));
    }
  }
}
</script>

<style scoped lang="scss">
.main-content {
  text-align: center;

  @media only screen and (max-width: 767px) {
    .card-container:nth-child(2n+1) {
      clear: left;
    }
  }
  @media only screen and (min-width: 768px) {
    .card-container:nth-child(3n+1) {
      clear: left;
    }
  }

  .ivu-card {
    margin: 40px auto;

    @include respond-to(phone) {
      h3 {
        font-size: 16px !important;
      }
    }
    @include respond-to(tablet) {
      h3 {
        font-size: 17px !important;
      }
    }

    .file {
      cursor: pointer;

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  ul {
    list-style: none;

    li {
      line-height: 24px !important;
    }
  }
}
</style>